import FirestoreDocument from "../../../types/FirestoreDocument";
import { boolean, int, intMinMax, literal, number, string, stringMinMax, union } from "../../../types/_types";

export const Price = FirestoreDocument.extend({
	approved: boolean(false),
	currency: stringMinMax(3, 3),
	employee: boolean(false),
	maxUses: union([intMinMax(1, 300), literal(false)]),
	name: string(3),
	price: number(),
	type: string(),
	unit: string(),
	uses: int().default(0),
	vat: int().default(0),
});
